<button *ngIf="showNotification" mat-icon-button (click)="showAlert()">
    <mat-icon class="has-alerts">notifications_active</mat-icon>
</button>
<button *ngIf="!showNotification" mat-icon-button disabled>
    <mat-icon class="no-alerts">notifications_none</mat-icon>
</button>